import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiStars = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#59BDC6",
		d: "m17.111 0 1.397 3.492L22 4.89l-3.492 1.397-1.397 3.492-1.397-3.492-3.492-1.397 3.492-1.397L17.111 0ZM17.111 13.689l1.397 3.492L22 18.578l-3.492 1.397-1.397 3.492-1.397-3.492-3.492-1.397 3.492-1.397 1.397-3.492Z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#B6DF59",
		d: "m8.8 2.933 1.956 6.845 6.844 1.955-6.844 1.956L8.8 20.533 6.844 13.69 0 11.733l6.844-1.955L8.8 2.933Z"
	})]
});
export default SvgAiStars;
